import gql from 'graphql-tag';

// The specific-percentage mutations return only their own rows, so the exclusion list cached
// on the testator query goes stale after those steps. Family obliteration fetches it fresh.
export const FAMILY_OBLITERATION_EXCLUDED_BENEFICIARIES_QUERY = gql`
  query familyObliterationExcludedBeneficiaries($testatorId: ID!) {
    remainderOfEstate(testatorId: $testatorId) {
      id
      familyObliterationExcludedBeneficiaries {
        beneficiaryType
        beneficiaryId
      }
    }
  }
`;

export const CREATE_REMAINDER_OF_ESTATE_MUTATION = gql`
  mutation createRemainderOfEstate(
    $remainderOfEstateInputDetails: RemainderOfEstateInput!
  ) {
    createRemainderOfEstate(
      remainderOfEstateInput: $remainderOfEstateInputDetails
    ) {
      id
      testatorId
      distribution
      alternativeDistribution
      distributionSpecificPercentages {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
        alternativeDistribution
        alternativeBeneficiaryId
        alternativeBeneficiaryType
        alternativeBeneficiaryDisplayName
        distributionSpecificPercentageAlternativeBeneficiaries {
          id
          distributionSpecificPercentageId
          percentage
          beneficiaryId
          beneficiaryType
          beneficiaryDisplayName
        }
      }
      alternativeDistributionSpecificPercentages {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
      }
      familyObliterationEnabled
      familyObliterationEqualShares
      familyObliterationNominees {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
      }
      familyObliterationExcludedBeneficiaries {
        beneficiaryType
        beneficiaryId
      }
    }
  }
`;

export const UPDATE_REMAINDER_OF_ESTATE_MUTATION = gql`
  mutation updateRemainderOfEstate(
    $id: ID!
    $remainderOfEstateInputDetails: RemainderOfEstateInput!
  ) {
    updateRemainderOfEstate(
      id: $id
      remainderOfEstateInput: $remainderOfEstateInputDetails
    ) {
      id
      testatorId
      distribution
      alternativeDistribution
      distributionSpecificPercentages {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
        alternativeDistribution
        alternativeBeneficiaryId
        alternativeBeneficiaryType
        alternativeBeneficiaryDisplayName
        distributionSpecificPercentageAlternativeBeneficiaries {
          id
          distributionSpecificPercentageId
          percentage
          beneficiaryId
          beneficiaryType
          beneficiaryDisplayName
        }
      }
      alternativeDistributionSpecificPercentages {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
      }
      familyObliterationEnabled
      familyObliterationEqualShares
      familyObliterationNominees {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
      }
      familyObliterationExcludedBeneficiaries {
        beneficiaryType
        beneficiaryId
      }
    }
  }
`;

export const PROCESS_DISTRIBUTION_SPECIFIC_PERCENTAGES_MUTATION = gql`
  mutation processDistributionSpecificPercentages(
    $distributionSpecificPercentageInputs: [DistributionSpecificPercentageInput!]!
    $deletedRecordIds: [ID!]!
  ) {
    processDistributionSpecificPercentages(
      distributionSpecificPercentageInputs: $distributionSpecificPercentageInputs
      deletedRecordIds: $deletedRecordIds
    ) {
      id
      percentage
      beneficiaryId
      beneficiaryType
      beneficiaryDisplayName
      alternativeDistribution
      alternativeBeneficiaryId
      alternativeBeneficiaryType
      alternativeBeneficiaryDisplayName
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
        distributionSpecificPercentageId
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
      }
    }
  }
`;

export const UPDATE_DISTRIBUTION_SPECIFIC_PERCENTAGE_MUTATION = gql`
  mutation updateDistributionSpecificPercentage(
    $id: ID!
    $distributionSpecificPercentageInputDetails: DistributionSpecificPercentageInput!
  ) {
    updateDistributionSpecificPercentage(
      id: $id
      distributionSpecificPercentageInput: $distributionSpecificPercentageInputDetails
    ) {
      id
      remainderOfEstateId
      beneficiaryId
      beneficiaryType
      beneficiaryDisplayName
      percentage
      alternativeDistribution
      alternativeBeneficiaryId
      alternativeBeneficiaryType
      alternativeBeneficiaryDisplayName
      distributionSpecificPercentageAlternativeBeneficiaries {
        id
        distributionSpecificPercentageId
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
      }
    }
  }
`;

export const PROCESS_ALTERNATIVE_DISTRIBUTION_SPECIFIC_PERCENTAGES_MUTATION = gql`
  mutation processAlternativeDistributionSpecificPercentages(
    $alternativeDistributionSpecificPercentageInputs: [AlternativeDistributionSpecificPercentageInput!]!
    $deletedRecordIds: [ID!]!
  ) {
    processAlternativeDistributionSpecificPercentages(
      alternativeDistributionSpecificPercentageInputs: $alternativeDistributionSpecificPercentageInputs
      deletedRecordIds: $deletedRecordIds
    ) {
      id
      beneficiaryId
      beneficiaryType
      beneficiaryDisplayName
      percentage
    }
  }
`;

export const PROCESS_FAMILY_OBLITERATION_NOMINEES_MUTATION = gql`
  mutation processFamilyObliterationNominees(
    $remainderOfEstateId: ID!
    $enabled: Boolean!
    $equalShares: Boolean!
    $familyObliterationNomineeInputs: [FamilyObliterationNomineeInput!]!
    $deletedRecordIds: [ID!]!
  ) {
    processFamilyObliterationNominees(
      remainderOfEstateId: $remainderOfEstateId
      enabled: $enabled
      equalShares: $equalShares
      familyObliterationNomineeInputs: $familyObliterationNomineeInputs
      deletedRecordIds: $deletedRecordIds
    ) {
      id
      testatorId
      distribution
      alternativeDistribution
      distributionSpecificPercentages {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
        alternativeDistribution
        alternativeBeneficiaryId
        alternativeBeneficiaryType
        alternativeBeneficiaryDisplayName
        distributionSpecificPercentageAlternativeBeneficiaries {
          id
          distributionSpecificPercentageId
          percentage
          beneficiaryId
          beneficiaryType
          beneficiaryDisplayName
        }
      }
      alternativeDistributionSpecificPercentages {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
      }
      familyObliterationEnabled
      familyObliterationEqualShares
      familyObliterationNominees {
        id
        percentage
        beneficiaryId
        beneficiaryType
        beneficiaryDisplayName
      }
      familyObliterationExcludedBeneficiaries {
        beneficiaryType
        beneficiaryId
      }
    }
  }
`;
